import './assets/css/default.scss';
import 'element-plus/theme-chalk/dark/css-vars.css';

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';

import App from './App.vue';
import router from './router';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import en from 'element-plus/es/locale/lang/en';
import ElementPlus from 'element-plus';

import { useLanguageStore } from '@/stores/languageStore.ts';
import i18n, { updateLocale } from '@/plugins/i18n.ts';
import { createSticky } from '@/utils/tableSticky.ts';
import { updateTickerHighchartLocale } from '@/views/stock/hooks/tickerHighchart.ts';

const app = createApp(App);
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
app.use(pinia);
app.use(router);

// 初始化语言设置
const languageStore = useLanguageStore();
languageStore.initLanguage();

// 根据当前语言设置Element Plus语言
const currentLocale = languageStore.currentLanguage === 'zh' ? zhCn : en;
app.use(ElementPlus, { locale: currentLocale });

// 设置 i18n 语言
updateLocale(languageStore.currentLanguage);
updateTickerHighchartLocale(languageStore.currentLanguage);

// 使用 i18n
app.use(i18n);

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

app.use(createSticky);
app.mount('#app');
